export default "__VITE_ASSET__DpG1Psww__"